export const wordsList = {
  partes_de_carro: ["Motor", "Porta", "Capô", "Pneu", "Antena"],
  fruta: ["Banana", "Maçã", "Pêra", "Mamão", "Laranja"],
  corpo: ["Braço", "Perna", "Cérebro", "Pescoço", "Olhos"],
  computador: ["Mouse", "Teclado", "Monitor", "Gabinete"],
  programação: ["Linguagem", "Framework", "JavaScript", "React"],
  alimento: ["Arroz", "Feijão", "Carne", "Leite", "Ovo"],
  marcas_de_carro: ["Audi", "Kia", "Pagani", "Ford", "Koegnisseg", "Bugatti"],
  Países: [
    "Australia",
    "Espanha",
    "Turquia",
    "Bulgaria",
    "Nigeria",
    "Azerbaijão",
    "Inglaterra",
    "Holanda",
    "Uruguai",
    "Argentina",
    "Chile",
    "Equador",
    "Catar",
  ],
};
